/*
  Shareable renderer for displaying the name of a tenant.
  Largely a copy/paste from the original table column.
*/
import React from 'react';
import { inject, observer } from 'mobx-react';
import TenantModel from 'app/stores/mkp/TenantModel';
import { Box, Link, Text } from 'core/components';
import LabelList from 'app/components/labels/LabelList';

interface Props {
  $auth: {
    isAdministrator: boolean;
  };
  model: TenantModel;
  value: string;
}

function TenantNameRenderer({ $auth, model, value }: Props) {
  return (
    <Box flexDirection="column">
      <Text fontWeight="bold" as="div" pb="2px" ellipsis>
        {$auth.isAdministrator ? <Link to={`/v4/mkp/tenants/${model.id}`}>{value}</Link> : <>{value}</>}
      </Text>
      <Text muted as="div" ellipsis>
        {model.get('description')}
      </Text>
      {/* @ts-expect-error skipping type check */}
      <LabelList labels={model.get('labels')} priorityLabels={model.collection.discreteFilterValues.label} />
    </Box>
  );
}

export default inject('$auth')(observer(TenantNameRenderer));
